import { Link } from 'react-router-dom';

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  actionLabel?: string;
  actionTo?: string;
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  actionLabel,
  actionTo,
}: SectionHeadingProps) {
  return (
    <div className="mb-6 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
      <div className="max-w-2xl">
        <div className="flex items-center gap-2">
          <span className="h-4 w-1 rounded-full bg-primary-500" />
          {eyebrow && <span className="text-xs font-medium tracking-[0.2em] text-primary-600">{eyebrow}</span>}
        </div>
        <h2 className="mt-2 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
          {title}
        </h2>
        {description && <p className="mt-2 text-sm leading-relaxed text-foreground-600 md:text-base">{description}</p>}
      </div>
      {actionLabel && actionTo && (
        <Link
          to={actionTo}
          className="group inline-flex shrink-0 items-center gap-1 whitespace-nowrap text-sm font-medium text-foreground-700 transition-colors hover:text-primary-600"
        >
          {actionLabel}
          <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" />
        </Link>
      )}
    </div>
  );
}